import { useDispatch, useSelector } from "react-redux";
import {
  selectIsInvoicePaymentBlocked,
  startInvoicePaymentTimeout,
} from "slices/payment/paymentSlice";


export const usePaymentBlocked = (invoiceNumber: string): [boolean, () => void] => {
  const dispatch = useDispatch();
  const isBlocked = useSelector(selectIsInvoicePaymentBlocked(invoiceNumber));

  const setBlocked = () =>
  {
    const invoiceNumbers = invoiceNumber.split(',');
    if (invoiceNumbers.length > 1) {
      invoiceNumbers.forEach(invoice => {
        dispatch(startInvoicePaymentTimeout(invoice));
        });
      } else {
        dispatch(startInvoicePaymentTimeout(invoiceNumber));
      }
    }
  

  return [isBlocked, setBlocked];
};